import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaCloudSun } from 'react-icons/fa';
import { SubMenu, MenuItem } from 'react-pro-sidebar';
import { fetchSpecialProductsNames } from '../../../../services/operations/specialProductsApi';
import {
  setSpecialProductsId,
  setForecastUrl,
} from '../../../../slices/allSpecialProductsSliceId';
import { fetchForecastUrl } from '../../../../services/operations/forecastAPI';

const ProductsList = () => {
  const dispatch = useDispatch();
  const selectedProductId = useSelector(
    (state) => state.allSpecialProductsId.selectedProductId
  );
  const [specialProducts, setSpecialProducts] = useState([]);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const products = await fetchSpecialProductsNames();
        setSpecialProducts(products);
      } catch (error) {
        console.error('Error fetching product names:', error);
      }
    };

    getProducts();
  }, []);

  const handleSelectProduct = async (product) => {
    dispatch(setSpecialProductsId(product.id));

    try {
      // console.log('Selected Product:', product);
      const model = 'UM-Reg4Km';
      const category = 'Severe-Weather-Warning';

      // Fetch the forecast URL using the encapsulated function
      const url = await fetchForecastUrl(
        model,
        product.url_product_name,
        category,
        product.type
      );
      if (url) {
        dispatch(setForecastUrl(url)); // Store the URL in Redux
      }
    } catch (error) {
      console.error('Error fetching forecast URL:', error);
    }
  };

  return (
    <div>
      <SubMenu
        label="Special Forecast Products"
        icon={<FaCloudSun />}
        style={{ pointerEvents: 'auto', backgroundColor: '#003244' }}
        className="my-4 text-xl"
      >
        {specialProducts.length > 0 ? (
          specialProducts.map((product) => (
            <MenuItem
              key={product.id}
              style={{
                pointerEvents: 'auto',
                backgroundColor: '#003244',
                color: '#e0f2ff',
              }}
              className="capitalize"
            >
              <label className="flex cursor-pointer items-center space-x-4">
                <input
                  type="radio"
                  name="specialProduct"
                  value={product.id}
                  checked={selectedProductId === product.id}
                  onChange={() => handleSelectProduct(product)}
                  className="size-4 text-blue-500"
                />
                <span className="text-lg capitalize">
                  {product.product_name}
                </span>
              </label>
            </MenuItem>
          ))
        ) : (
          <MenuItem
            style={{ pointerEvents: 'none', backgroundColor: 'transparent' }}
          >
            No special products available
          </MenuItem>
        )}
      </SubMenu>
    </div>
  );
};

export default ProductsList;
